import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';
import Loader from '../Loader/Loader';

interface AreaSubscriptionGuardProps {
  children: React.ReactNode;
}

const AreaSubscriptionGuard: React.FC<AreaSubscriptionGuardProps> = ({ children }) => {
  const { loading: authLoading } = useAuth();
  const { hasSubscription, openSubscriptionModal } = useSubscription();

  useEffect(() => {
    if (!authLoading && !hasSubscription) {
      openSubscriptionModal();
    }
  }, [authLoading, hasSubscription, openSubscriptionModal]);

  if (authLoading) {
    return <Loader fullScreen size="large" />;
  }

  if (!hasSubscription) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AreaSubscriptionGuard;
